function formatGermanNumber(input, decimals = true, strict = false) {
    // Check if input ends with comma and digits
    const commaMatch = input.match(/(.+?)(,.*)$/);
    const hasCommaEnding = commaMatch !== null;
    
    // Normalize input: remove thousands dots, turn comma into dot
    let clean = input.replace(/\./g, '').replace(',', '.');
  
    if (clean === '') return '';
  
    let num = parseFloat(clean);
    if (isNaN(num)) return '';
  
    let int, dec;
  
    if (strict) {
      [int, dec] = num.toFixed(2).split('.');
    } else {
      [int, dec = ''] = clean.split('.');
    }
  
    // Add thousand separators to integer part
    let intFormatted = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
    if (!decimals) {
      if (hasCommaEnding) return intFormatted + commaMatch[2]
      return intFormatted;
    }
  
    return dec !== undefined && dec !== ''
      ? intFormatted + ',' + (strict ? dec : dec.slice(0, 2))
      : intFormatted;
}